import React, { Component } from 'react';
import Header from './Header';

import image1 from '../assets/_Alex_PRO_NEW.png';
import image3 from '../assets/3taylorcarusoactually.png';
import image4 from '../assets/4wkndhardpost.png';
import image6 from '../assets/6evancalebintro.png';
import image7 from '../assets/7sirpalmerrough.png';
import image8 from '../assets/8trumon.png';
import image9 from '../assets/9sirpalmer.png';
import image10 from '../assets/10stories.png';
import image11 from '../assets/11_Maalouf.png';
import image12 from '../assets/12sullyintroskit.png';
import image13 from '../assets/13goodfools.png';
import image14 from '../assets/14alexiswknd.png'
import image15 from '../assets/15wkndvsnike.png'
import image16 from '../assets/16jordanpropart.png'
import image17 from '../assets/17jordanproskit.png'
import image18 from '../assets/18wkndhawaii2.png'
import image23 from '../assets/23whostosay.png'
import image24 from '../assets/24austynskit.png'
import image25 from '../assets/25fingerboarderskit.png'
import image26 from '../assets/26shipping.png'
import image27 from '../assets/27wkndfirstpro.png'
import image28 from '../assets/28kostonwelcome.png'
import image29 from '../assets/29nicedeck2.png'
import image30 from '../assets/30wkndbaseball.png'
import image31 from '../assets/31drewtrevorintro.png'
import image34 from '../assets/34taylorwelcome.png'
import image35 from '../assets/35wkndsf.png';
import image36 from '../assets/36mostbeautiful2.png';
import image38 from '../assets/38molinarmetro2.png';
import image39 from '../assets/DEATH_DANCE.png';
import image40 from '../assets/grant_drop_in_grind_silverlake.png';



const videos = [
  {
    title: 'Trang 50 Part',
    link: 'https://www.youtube.com/watch?v=M0iEI0H751g',
    img_path: image40
  },
  {
    title: 'DEATH DANCE',
    link: 'https://www.youtube.com/watch?v=_gPbD3PmYjE',
    img_path: image39
  },
  {
    title: 'Alex Schmidt WKND Professional',
    link: 'https://www.youtube.com/watch?v=qnWgMGZE7qs',
    img_path: image1
  },
  {
    title: 'Taylor Caruso, actually',
    link: 'https://www.youtube.com/watch?v=YRY_3_UKVag&t=',
    img_path: image3
  },
  {
    title: 'Hard Post - WPB / MIA',
    link: 'https://www.youtube.com/watch?v=M2GpGTx1Zvs',
    img_path: image4
  },
  {
    title: 'Caleb | Evan - Welcome to WKND',
    link: 'https://www.youtube.com/watch?v=-eO699pdqRs',
    img_path: image6
  },
  {
    title: `Rough Cut: WKND's "Sir Palmer" Video`,
    link: 'https://www.youtube.com/watch?v=V_NLTsv3enU&t=',
    img_path: image7
  },
  {
    title: 'The Tru Mon Show',
    link: 'https://www.youtube.com/watch?v=9GkIHIKe0O4&t=1s',
    img_path: image8
  },
  {
    title: `WKND's "Sir Palmer" Video`,
    link: 'https://www.youtube.com/watch?v=5JnjGLk-gVA&t=',
    img_path: image9
  },
  {
    title: `WKND "Stories"`,
    link: 'https://www.youtube.com/watch?v=6sqKHiA62XE&t=',
    img_path: image10
  },
  {
    title: `Christian Maalouf WKND Part`,
    link: 'https://www.youtube.com/watch?v=MGEysoVTEKY&t=',
    img_path: image11
  },
  {
    title: `Salomon Cardenas - Welcome to WKND`,
    link: 'https://www.youtube.com/watch?v=U_spjTKKyEg',
    img_path: image12
  },
  {
    title: `WKND - GoodFools`,
    link: 'https://www.youtube.com/watch?v=fH6ZElaGZ_8',
    img_path: image13
  },
  {
    title: `Alexis Sablone - Welcome to WKND`,
    link: 'https://www.youtube.com/watch?v=Hv_mufnqdgM&t=0s',
    img_path: image14
  },
  {
    title: `WKND vs.NIKE Baseball game`,
    link: 'https://www.youtube.com/watch?v=5F9d8Kcevbg&t=0s',
    img_path: image15
  },
  {
    title: `Jordan Taylor WKND Part`,
    link: 'https://www.youtube.com/watch?v=LFqckmL5aQs&t=0s',
    img_path: image16
  },
  {
    title: `Jordan Taylor WKND Professional`,
    link: 'https://www.youtube.com/watch?v=esol6TgIj0Y&t=0s',
    img_path: image17
  },
  {
    title: `WKND in Hawaii`,
    link: 'https://www.youtube.com/watch?v=g0CBkAvmpHo&t=0s',
    img_path: image18
  },
  {
    title: `WKND - Who's to say`,
    link: 'https://www.youtube.com/watch?v=G00htZvkUrI&t=0s',
    img_path: image23
  },
  {
    title: `Austyn Gillette for WKND`,
    link: 'https://www.youtube.com/watch?v=2KaoHCPGjbw&t=0s',
    img_path: image24
  },
  {
    title: `WKND Finger Skater Owned and Operated`,
    link: 'https://www.youtube.com/watch?v=LljU2YZuckU&t=0s',
    img_path: image25
  },
  {
    title: `WKND Shipping Series`,
    link: 'https://www.youtube.com/watch?v=eAjqIMSp0HE&t=0s',
    img_path: image26
  },
  {
    title: `WKND announces first PRO board`,
    link: 'https://www.youtube.com/watch?v=fagYhXWqPVY&t=0s',
    img_path: image27
  },
  {
    title: `Koston welcome to WKND part`,
    link: 'https://www.youtube.com/watch?v=vTi8T5EdG3M&t=0s',
    img_path: image28
  },
  {
    title: `WKND Nice Decks`,
    link: 'https://www.youtube.com/watch?v=wqjMSO2S2j8&t=0s',
    img_path: image29
  },
  {
    title: `WKND Baseball`,
    link: 'https://www.youtube.com/watch?v=4bL3_B_2fO8&t=0s',
    img_path: image30
  },
  {
    title: `Andrew Considine & Trevor Thompson Welcome To WKND`,
    link: 'https://www.youtube.com/watch?v=pFDxw84N-uc&t=0s',
    img_path: image31
  },
  {
    title: `Taylor "Big Dahg" Caruso Welcome to WKND`,
    link: 'https://www.youtube.com/watch?v=dA3aOheuNlk&t=0s',
    img_path: image34
  },
  {
    title: 'WKND in SF',
    link: 'https://www.youtube.com/watch?v=1HOe602Ceqs&t=0s',
    img_path: image35
  },
  {
    title: 'WKND Beauty "The Most Beautiful Thing Ever Filmed"',
    link: 'https://www.youtube.com/watch?v=HUn38kqqIzQ',
    img_path: image36
  },
  {
    title: `Raymond Molinar's "Metro Lines" Part`,
    link: 'https://www.youtube.com/watch?v=YNqtOFtnc78&t=0s',
    img_path: image38
  },
]

class Video extends Component {

  render() {
    return (
      <div className="site-wrap">
        <Header page="video" />
        <div className="video-page-wrap">
        {
          videos.map(({ title, link, img_path}) => {
            const hyper = `${link}`
            return (
              <div key={img_path} className="video-wrap" style={{ padding: '10px' }}>
                <a href={hyper} target="_blank">
                  <img src={img_path} alt={title} style={{ width: '300px', height: '200px'}}/>
                </a>
                <span style={{ textAlign: 'center', fontSize: '10px' }}>{title}</span>
              </div>
            )
          })
        }

        </div>
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video.js